module.exports = __webpack_public_path__ + "static/media/img6.d0bce9f7.jpg";